import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    if (!email.trim()) return;
    setLoading(true);
    try {
      await fetch('https://readdy.ai/api/form/d90j6qa181e9e92u9460', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: email.trim() }).toString(),
      });
    } catch {
      /* fetch failed silently */
    }
    setLoading(false);
    setSubmitted(true);
    setEmail('');
  };

  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-[40px] mt-16 mx-4 md:mx-6">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="font-heading text-3xl md:text-4xl font-medium mb-3">Stay Updated</h3>
            <p className="text-foreground-300 text-sm mb-8 leading-relaxed">
              Get the latest Vigorbuy Spreadsheet updates, new category additions, and exclusive buying guides delivered straight to your inbox.
            </p>
            {submitted ? (
              <p className="text-secondary-300 text-sm font-medium">Thank you for subscribing! We will keep you updated.</p>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                <input
                  type="text"
                  name="website_alt"
                  className="hp-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="flex-1 bg-transparent border-b border-foreground-600 text-background-50 text-sm py-2.5 px-1 outline-none placeholder:text-foreground-500 focus:border-background-50 transition-colors"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2.5 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {loading ? 'Subscribing...' : 'Subscribe'}
                  <i className="ri-arrow-right-line ml-1.5"></i>
                </button>
              </form>
            )}
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">Navigate</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4">Home</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4">Categories</a></li>
              <li><Link to="/what-is-vigorbuy-sheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4">Guides</Link></li>
              <li><Link to="/what-is-vigorbuy-sheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4">Safety</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3">
              <li className="text-sm text-foreground-300">support@vigorbuy.best</li>
              <li className="text-sm text-foreground-300">+1 (888) 555-VIGO</li>
            </ul>
            <h4 className="text-sm font-semibold text-background-50 mb-3 mt-6 uppercase tracking-wider">Location</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              315 W 36th Street, Suite 402<br />
              New York, NY 10018
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-700 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4">Twitter</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4">Instagram</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4">Pinterest</a>
          </div>
          <p className="text-sm text-foreground-500">&copy; 2026 VigorBuy.best</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4">Privacy</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}